module.exports = __webpack_public_path__ + "assets/img/Large.8197752d.svg";